import { Component } from '@angular/core';
import { COLUMNS_HEADER_JOBS_ADMIN } from '../../core/constants/tables.constants';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { Router } from '@angular/router';
import { JobsService } from '../../core/services/jobs.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';

@Component({
  selector: 'app-jobs',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, SpinnerComponent, GenericTableComponent],
  templateUrl: './jobs.component.html',
  styleUrl: './jobs.component.scss'
})
export class JobsComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_JOBS_ADMIN;

  jobs: any;

  isLoading = false;
  hasError = false;
  faSpinner = faSpinner;
  constructor(
    private jobsSvc: JobsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getJobs();
  }

  getJobs() {
    this.jobsSvc.getJobs().subscribe((res: any) => {
      this.jobs = res;
      this.isLoading = false;
    });
  }

  goToDetail(job: any) {
    this.router.navigate(['/jobs', job.code]);
  }


}
